import type { TransactionOperation } from "."
import { isSnappingOnState } from "../panels"

export const resetPanelSnapToggle: TransactionOperation = (transactors) => {
  const { set } = transactors
  set(isSnappingOnState, true)
}
